<template>
  <div class="customer-case main-container light-bg">
    <v-layout align-center class="grid grid-one light-bg">
        <h3 class="display-3">Support</h3>
        <p class="sub-headline">Ladda ner vår modul för enkel fjärrsupport.</p>
    </v-layout>
    <v-layout class="grid grid-one blue-bg" style="min-height:70vh;">
        <p>För att kunna hjälpa dig  på bästa & snabbaste sätt så är TeamViewer den bästa lösningen. <br>TeamViewer låter oss fjärrstyra din dator och vi kan på detta sättet hjälpa er i realtid och felsöka lösningar, etc.<br/><br/>
        1. Välj operativsystem nedan. <br/>
        2. Ladda ner och installera programmet.</p>
    <div align-center class="customer-case-grid half blue-bg" style="padding-top:40px;">
      <a href="./files/prgr/TeamViewerQS.zip" download="">
        <section class="cs-grid-item grid-one blue-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out" style="padding-top:20px;">
          <h3 class="display-3" style="text-align:center;">FJÄRRSUPPORT<br>MAC</h3>
            <div class="read-more" style="text-align: center">
              <button><v-icon style="color: whitesmoke;font-size:34px;margin-bottom:20px;">save_alt</v-icon><br>FÖR MAC
              <span class="system-specs" style="text-transform: lowercase;">(ca. 45MB)</span></button>
            </div>
        </section>
      </a>
      <a href="./files/prgr/TeamViewerQS_sv.exe" download="">
        <section class="cs-grid-item grid-one blue-bg" data-aos="fade-in" data-aos-duration="800" data-aos-easing="ease-in-out" style="padding-top:20px;">
          <h3 class="display-3" style="text-align:center;">FJÄRRSUPPORT<br>WINDOWS</h3>
            <div class="read-more" style="text-align: center">
              <button><v-icon style="color: whitesmoke;font-size:34px;margin-bottom:20px;">save_alt</v-icon><br>FÖR WINDOWS
              <span class="system-specs" style="text-transform: lowercase;">(ca. 22MB)</span></button>
            </div>
        </section>
      </a>

    </div>
    </v-layout>
    
  </div>

</template>
<script>
    import { Component, Vue } from "vue-property-decorator";

    @Component({
        data(){
            return {}
        },
        components: {},
        methods: {}
    })
    export default class Support extends Vue {}
</script>
<style lang="scss">
 
</style>
